import { IOpData, IOpChangeState, ICopyable } from '../util/interfaces'
import { Enums } from '../common/enums'

import { OpDataType } from '../core/op-data-type'


export class OpDistributorData implements IOpData, IOpChangeState, ICopyable<OpDistributorData> {

    // #region Properties

    public idDistributorData: number
    public idDistributor: number
    public idDataType: number
    public indexNbr: number
    public value: any

    // #endregion


    // #region NavigationProperties

    private _dataType: OpDataType = null
    public get dataType(): OpDataType {
        return this._dataType
    }
    public set dataType(value: OpDataType) {
        this._dataType = value
        this.idDataType = value != null ? value.idDataType : null
    }

    // #endregion


    //#region Ctor

    constructor(opObj: any) {
        if (opObj instanceof OpDistributorData) {
            this.copy(<OpDistributorData>opObj, true, true, true, true)
        } else {
            this.fromJSON(opObj)
        }
    }

    //#endregion


    // #region IOpChangeState

    public opState: Enums.OpChangeState

    // #endregion


    // #region IOpData

    public get idData() { return this.idDistributorData }
    public set idData(idData: number) { this.idDistributorData = idData }
    public get indexNBR() { return this.indexNbr }
    public set indexNBR(indexNBR: number) { this.indexNbr = indexNBR }

    // #endregion


    //#endregion IJsonSerializable Implementation

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            this.dataType = opObj._DataType != null ? new OpDataType(opObj._DataType) : null

            this.idDistributorData = opObj.ID_DISTRIBUTOR_DATA
            this.idDistributor = opObj.ID_DISTRIBUTOR
            this.idDataType = opObj.ID_DATA_TYPE
            this.indexNbr = opObj.INDEX_NBR
            this.value = opObj.VALUE
            this.opState = opObj.OpState
        }

    }

    public toJSON(compressed: boolean = false): any {
        return {
            ID_DISTRIBUTOR_DATA: this.idDistributorData,
            ID_DISTRIBUTOR: this.idDistributor,
            ID_DATA_TYPE: this.idDataType,
            INDEX_NBR: this.indexNbr,
            VALUE: this.value,
            OpState: this.opState
        }
    }

    // #endregion


    // #region ICopyable

    public clone(includeNavigationProperties: boolean, includeCustomProperties: boolean, includeDataList: boolean, includeDynamicValues: boolean): OpDistributorData {
        const data: OpDistributorData = new OpDistributorData(null)

        data.copy(this, includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)

        return data
    }

    public copy(source: OpDistributorData, includeNavigationProperties: boolean, includeCustomProperties: boolean, includeDataList: boolean, includeDynamicValues: boolean): void {
        if (source == null) {
            return
        }

        if (includeNavigationProperties) {
            if (source.dataType != null) {
                this.dataType = source.dataType.clone(includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)
            }
        }

        if (includeCustomProperties) {
            // No Custom Properties
        }

        if (includeDataList) {
            // No Data List
        }

        if (includeDynamicValues) {
            // No Dynamic Values
        }

        this.idDistributorData = source.idDistributorData
        this.idDistributor = source.idDistributor
        this.idDataType = source.idDataType
        this.indexNbr = source.indexNbr
        this.value = source.value
        this.opState = source.opState
    }

    // #endregion


    //#region fromIOpData

    public static fromIOpData(data: IOpData): OpDistributorData {
        const newData: OpDistributorData = new OpDistributorData(null)

        newData.idDistributorData = data.idData
        newData.idDataType = data.idDataType
        newData.indexNbr = data.indexNBR
        newData.value = data.value
        newData.opState = data.opState

        return newData
    }

    //#endregion
}